// extracted by mini-css-extract-plugin
export var indeterminate = "_4p-6";
export var md = "_4p-5";
export var semantic = "_4p-7";
export var sm = "_4p-4";
export var text = "_4p-8";
export var toggleControl = "_4p-0";
export var toggleInput = "_4p-1";
export var toggleSwitch = "_4p-2";
export var xs = "_4p-3";